module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/print.json
// module id = 620
// module chunks = 8489241299891